import styles from "../styles/businessSelectionList.module.css";
import AdminUserBusinessListItem from "./adminUserBusinessListItem";

interface AdminUserBusinessListProps {
  businesses: any;
  onSelect: Function;
  action: "add" | "remove";
  handler: Function;
}

const AdminUserBusinessList = ({ businesses, onSelect, action, handler }: AdminUserBusinessListProps) => {
  return (
    <div className={styles.container}>
      {businesses.map((business: any) => {
        return (
          <div
            style={{ width: "100%" }}
            onClick={() => {
              console.log("business", business);
              if (business.businessType) {
                console.log("business", business);
                handler({
                  businessId: business.businessId,
                  businessType: business.businessType,
                });
              } else {
                handler({
                  businessId: business.id,
                  businessType: business.type ? "venue" : "brand",
                });
              }
            }}
          >
            <AdminUserBusinessListItem
              avatar={business[business.businessType]?.avatarUrl || business.avatarUrl}
              name={`${business[business.businessType]?.name || business.name} - ${business[business.businessType]?.street || business.street || ""}`}
              action={action}
              handler={handler}
            />
          </div>
        );
      })}
    </div>
  );
};

export default AdminUserBusinessList;
